import type { FC } from "react";
import React from "react";
import { useLocation } from "react-router-dom";

import { ErrorView } from "@react/foundation/placeholder";

import { OAuthRequestIdSchema } from "@apis/account/models";

import { ConsentRequest } from "./ConsentRequest.tsx";

export const OAuthConsentView: FC = () => {
  const { search } = useLocation();
  const requestId = new URLSearchParams(search).get("requestId");
  const parsed = OAuthRequestIdSchema.safeParse(requestId);

  if (!parsed.success) {
    return <ErrorView description="This consent link is not valid." />;
  }

  return <ConsentRequest id={parsed.data} />;
};
